import React, { useContext, useState } from 'react'
import classNames from 'classnames'
import config from 'config'
import { BellOutlined } from '@ant-design/icons'
import { Badge, Popover } from 'antd'

import './styles.less'
import { observer } from 'mobx-react-lite'
import { EasyDrawContext } from '@/store'
import { useNavigate } from 'react-router-dom'
import NotificationList from './NotificationList'
import { NotificationEntity } from '@/store/notification'
import { NotificationStatus } from '@shared/constants/notification'

export type NotificationProps = {
  className?: string
}

export const Notification = observer((props: NotificationProps) => {
  const { className } = props
  const store = useContext(EasyDrawContext)
  const notification = store.notificationStore
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)


  // 处理标记所有消息为已读
  const handleMarkAllAsRead = () => {
    notification.readAllNotification()
  }

  // 处理消息点击事件
  const handleNotificationClick = (item: NotificationEntity) => {
    try {
      // 标记消息为已读
      if (item.status === NotificationStatus.UNREAD) {
        notification.readNotification(item.id)
      }
    } catch (error) {
      console.error('处理消息点击事件出错:', error)
    }
  }

  // 气泡卡片内容
  const content = (
    <div className="notification-popover">
      <NotificationList 
        notifications={notification.notificationList} 
        loading={notification.loading}
        onItemClick={handleNotificationClick}
        onLoadMore={notification.loadMore.bind(notification)}
        hasMore={notification.hasMore}
      />
      <div className="notification-footer">
        <a 
          onClick={handleMarkAllAsRead}
          className={!notification.notificationList.length || !notification.unreadCount ? 'disabled' : ''}
          style={{ 
            cursor: !notification.notificationList.length || !notification.unreadCount ? 'not-allowed' : 'pointer',
            color: !notification.notificationList.length || !notification.unreadCount ? '#00000040' : '#1890ff'
          }}
        >
          标记全部已读
        </a>
      </div>
    </div>
  )
  if (!store.isLogin) {
    return null
  }
  return (
    <div className={classNames('notification-component', className)}>
      <Popover
        content={content}
        title="消息通知"
        open={visible}
        onOpenChange={setVisible}
        placement="bottomRight"
        className="notification-popover-container"
      >
        <Badge count={notification.unreadCount} overflowCount={99}>
          <BellOutlined className="notification-icon" />
        </Badge>
      </Popover>
    </div>
  )
})